import React, { useState, useEffect } from 'react'
import i18n from 'live/services/i18n'
import WebSettingsCard from 'live/components/ui/admin/web-settings-card'
import FormGroup from 'live/components/forms/ui/form-group'
import globalNotification from 'live/services/global-notification'
const RESOURCE_URL = '/services/plugin-asset-aggregator/configuration/executor'

const Configuration = (): JSX.Element => {
    const [editMode, setEditMode] = useState(false)
    const [saved, setSaved] = useState(false)
    const [loading, setLoading] = useState(true)
    const [configPayload, setConfigPayload] = useState({ workers: 4, queueSize: 1024 })

    useEffect(() => {
        fetch(RESOURCE_URL)
            .then(resp => {
                return resp.json()
            })
            .then(data => {
                setConfigPayload(data)
            })
            .catch(error => {
                globalNotification.failed(i18n('Failed to get the path', error))
            })
            .finally(() => {
                setLoading(false)
            })
    }, [])

    const onSave = (): void => {
        const headers = {
            'content-type': 'application/json'
        }

        const body = {
            ...configPayload
        }

        setLoading(true)

        fetch(RESOURCE_URL, { method: 'POST', body: JSON.stringify(body), headers })
            .then(resp => {
                if (resp.status !== 200) return Promise.reject(resp)
                setEditMode(false)
                setSaved(true)
                globalNotification.success(i18n('Settings successfully saved'))
            })
            .catch(error => {
                error.json().then(payload => {
                    globalNotification.error(i18n('Failed to save settings') + ': ' + i18n(payload.message))
                })
            })
            .finally(() => {
                setLoading(false)
            })
    }

    return (
        <WebSettingsCard
            name="aggregator-executor-config"
            className="live-feature"
            open={editMode}
            error={''}
            saved={saved}
            save={onSave}
            hideButton={loading}
            savedMessage={i18n('Aggregator Configuration settings successfully saved')}
            toggle={(name, status) => {
                setEditMode(status === 'open')
                setSaved(status !== 'open')
            }}
        >
            <h2>{i18n('Executor Configuration')}</h2>
            {loading ? <span>{i18n('Loading from server...')}</span> : (
                <>
                    <FormGroup
                        type="number"
                        label={i18n('Workers')}
                        name="workers"
                        value={configPayload.workers}
                        placeholder=""
                        hideInput={!editMode}
                        onChange={({ target }) => {
                            setConfigPayload({ ...configPayload, workers: target.value })
                        }}
                        help={i18n("The setting will only be applied after asset-aggregator restart")}
                    />
                    <FormGroup
                        type="number"
                        label={i18n('Queue Size')}
                        name="queueSize"
                        value={configPayload.queueSize}
                        placeholder=""
                        hideInput={!editMode}
                        onChange={({ target }) => {
                            setConfigPayload({ ...configPayload, queueSize: target.value })
                        }}
                        help={i18n("The setting will only be applied after asset-aggregator restart")}
                    />
                </>
            )}
        </WebSettingsCard>
    )
}

export default {
    name: i18n('Configuration'),
    key: 'aggregator-executor-config',
    section: i18n('Asset Aggregator Settings'),
    configComponent: Configuration
}
